import { Component, OnInit } from '@angular/core';
import { serviceURLService } from '../service/serviceURL';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import moment from 'moment';
// import { $ } from 'protractor';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
declare var $: any;

@Component({
  selector: 'app-team-member-leave-calender',
  templateUrl: './team-member-leave-calender.component.html',
  styleUrls: ['./team-member-leave-calender.component.css']
})
export class TeamMemberLeaveCalenderComponent implements OnInit {
  data: any = {};
  userID: any;
  name: any;
  teamMemberDetails: Array<any> = [];
  teamMemberList: Array<any> = [];
  leaveLeft: Array<any> = [];
  showRows: any = [];
  lat: any;
  lng: any;
  comment: any;
  //backClicked: any;
  checkInDetails: any;
  updatedTime: any;
  error: any;
  successMessage: any;
  errorMessage: any;
  teamMemberUserId: any;
  approvalStatus: any;
  memberUserID: any;
  pendingLeaveModalData: any;
  leaveDate: number;
  requestTypeLeave: any;
  requestTimeLeave: any;
  pandingIdLeave: any;
  pendingLeavesRequestData: any = [];
  checInDatalengthArr = [];
  checOutDatalengthArr = [];
  checLeaveDatalengthArr = [];
  pendingLeaveStatus: string;
  supervisorComment: any;
  storedDates: Array<any> = [];
  minimumDate = new Date();
  selectedDates: any = [];
  value: Date[];
  urlID: any;
  invalidDates: Array<any> = [];
  private onDestroy$: Subject<void> = new Subject<void>();

  public iconVisibility1: boolean = true;

  constructor(private router: Router, private activatedRoute: ActivatedRoute, private serviceURLService: serviceURLService, private _location: Location) {
    this.userID = localStorage.getItem('userID');
    this.name = localStorage.getItem('name');
    if (navigator) {

      navigator.geolocation.getCurrentPosition(pos => {
        this.lng = +pos.coords.longitude;
        this.lat = +pos.coords.latitude;
      });
    }
  }

  ngOnInit() {
    //this.getTeamMember();
    this.approvalStatus = "OK";
    this.pendingLeaveStatus = "Paid;"
    this.activatedRoute.params.pipe(takeUntil(this.onDestroy$)).subscribe(paramsId => {
      this.urlID = paramsId.id;
      console.log(this.urlID);
    });
    this.teamMemberLeaveCalender();
    //console.log("url",this.urlID);

  }

  leaveApplied: any = [];
  leaveCancelled: any = [];

  changedExtraHandler(event) {
    //NOTE: At a time only cancellation of application of new leave can take plase.

    if (this.value.length > this.selectedDates.length) {
      console.log("-------------ADDITION----------------");
      var leaveApplied = this.findNewAddedDate(this.value, this.selectedDates);

      //If user selects the already applied date then don't allow.
      var dateNotToDeselect = this.findNewAddedDate(this.selectedDates, this.value);
      if (dateNotToDeselect.length > 0) {
        $("#ignoreSelection").modal("show");
        this.teamMemberLeaveCalender();
        $(".errorMessage").text("To cancel leave please deselect the date you want to apply leave.")
        this.reSelectWrongSelectedDateWhileApplication(dateNotToDeselect);
      } else {
        this.leaveApplied = leaveApplied;
      }

    } else if (this.selectedDates.length > this.value.length) {
      console.log("-------------CANCELLATION----------------");

      //If user tries to select new date along with cancellation i.e. tries to apply leave.
      var leaveApplied = this.findNewAddedDate(this.value, this.selectedDates);
      if (leaveApplied.length > 0) {
        this.deSelectWrongSelectedDateWhileCancellation(leaveApplied[0]);
      }

      var leaveCancelled = this.findNewAddedDate(this.selectedDates, this.value);

      for (var i = 0; i < leaveCancelled.length; i++) {
        if (leaveCancelled[i] < this.minimumDate) { //Old applied leaves cannot be cancelled.
          $("#ignoreSelection").modal("show");
          this.teamMemberLeaveCalender();
          $(".errorMessage").text("Oops..!! You can't cancel the previous leave.");
          this.reSelectWrongSelectedDateWhileCancellation(leaveCancelled[i]);
        } else {
          //Add new cancelled leave only if it doesn't exists in the this.leaveCancelled
          var doesCancelledDateAlreadyExists = false;
          for (var j = 0; j < this.leaveCancelled.length; j++) {
            if (this.leaveCancelled[j] == leaveCancelled[i]) {
              doesCancelledDateAlreadyExists = true;
            }
          }
          if (!doesCancelledDateAlreadyExists) {
            this.leaveCancelled.push(leaveCancelled[i]);
          }

          //If User has again selected the cancelled dates i.e. don't wanna cancel a date.
          for (var j = 0; j < this.leaveCancelled.length; j++) {
            var isCancelledDateRevoked = false;
            for (var k = 0; k < leaveCancelled.length; k++) {
              if (this.leaveCancelled[j] == leaveCancelled[k]) {
                var isCancelledDateRevoked = true;
              }
            }

            //Remove the unselected date from list and add in view.
            if (!isCancelledDateRevoked) {
              this.reSelectWrongSelectedDateWhileCancellation(this.leaveCancelled[j]);
              this.leaveCancelled.splice(j, 1);
            }
          }
        }
      }
    } else if (this.selectedDates.length == this.value.length) {
      console.log("Special case");
      //If user started applying first then don't allow cancellation functionality
      if (this.leaveApplied.length > 0) {
        var dateNotToDeselect = this.findNewAddedDate(this.selectedDates, this.value);
        if (dateNotToDeselect.length > 0) {
          $("#ignoreSelection").modal("show");
          this.teamMemberLeaveCalender();
          $(".errorMessage").text("To apply leave please deselect the date you want to cancel leave.")
          this.reSelectWrongSelectedDateWhileApplication(dateNotToDeselect);
        } else {
          //Case if user apply and then deselect the same date in one go
          this.leaveApplied.length = 0;
        }
      } else if (this.leaveCancelled.length > 0) {
        //If user started cancellation first then don't allow apply functionality
        var isRejectionWithAppliedLeave = this.findNewAddedDate(this.value, this.selectedDates);
        console.log("Testing " + isRejectionWithAppliedLeave);
        if (isRejectionWithAppliedLeave.length > 0) {
          $("#ignoreSelection").modal("show");
          this.teamMemberLeaveCalender();
          $(".errorMessage").text("To cancel leave please deselect the date you want to apply leave.")
          this.deSelectWrongSelectedDateWhileCancellation(isRejectionWithAppliedLeave[0]);
        } else {
          //Case if user cancel and then reselect the same date in one go.
          this.leaveCancelled.length = 0;
        }
      } else {
        console.log("else condition");
      }
    }
    console.log("Leaves Applied: " + this.leaveApplied);
    console.log("Leaves Cancelled: " + this.leaveCancelled);
  }

  findNewAddedDate(firstIterator, secondIterator) {
    var allDates = [];
    for (let i = 0; i < firstIterator.length; i++) {
      var valueExists = false;

      for (var j = 0; j < secondIterator.length; j++) {
        if (String(secondIterator[j]) == String(firstIterator[i])) {
          valueExists = true;
        }
      }

      if (!valueExists) {
        allDates.push(firstIterator[i]);
      }
    }
    return allDates;
  }

  //Case if any date is selected which cannot be applied
  reSelectWrongSelectedDateWhileApplication(dateNotToDeselect) {
    this.value.length = 0;

    var newValue = [];
    newValue.push(dateNotToDeselect[0]);

    for (var i = 0; i < this.selectedDates.length; i++) {
      if (this.selectedDates[i] != dateNotToDeselect) {
        newValue.push(this.selectedDates[i]);
      }
    }

    for (var i = 0; i < this.leaveApplied.length; i++) {
      newValue.push(this.leaveApplied[i]);
    }

    this.value = newValue;
  }

  //Case if any date is selected which cannot be cancelled.
  reSelectWrongSelectedDateWhileCancellation(dateNotToDeselect) {
    this.value.length = 0;

    var newValue = [];
    newValue.push(dateNotToDeselect);

    for (var i = 0; i < this.selectedDates.length; i++) {
      var valueExists = false
      for (var j = 0; j < this.leaveCancelled.length; j++) {
        if (this.selectedDates[i] == this.leaveCancelled[j]) {
          valueExists = true;
        }
      }

      if (!valueExists && (this.selectedDates[i] != dateNotToDeselect)) {
        newValue.push(this.selectedDates[i]);
      }
    }
    this.value = newValue;
  }

  //Case if any date is selected which cannot be cancelled. Or user tries to apply.
  deSelectWrongSelectedDateWhileCancellation(dateNotToDeselect) {
    //Issue in this function as it takes user back to starting month.
    this.value.length = 0;

    var newValue = [];

    for (var i = 0; i < this.selectedDates.length; i++) {
      var valueExists = false
      for (var j = 0; j < this.leaveCancelled.length; j++) {
        if (this.selectedDates[i] == this.leaveCancelled[j]) {
          valueExists = true;
        }
      }

      if (!valueExists && (this.selectedDates[i] != dateNotToDeselect)) {
        newValue.push(this.selectedDates[i]);
      }
    }
    this.value = newValue;
  }

  submitLeaveAction() {
    if (this.leaveApplied.length > this.leaveCancelled.length) {
      this.applyLeavebySupervisor();
    } else if (this.leaveApplied.length < this.leaveCancelled.length) {
      this.cancelLeaves();
    }
    else {
      $("#ignoreSelection").modal("show");
      this.teamMemberLeaveCalender();
      $(".errorMessage").text("Please select any date to perform action.")
    }
  }

  applyLeavebySupervisor() {
    if (!this.comment) {
      $("#ignoreSelection").modal("show");
      $(".errorMessage").text("Please add comment.")
      return;
    }
    var applyLeaveSelectedDates = []
    for (var i = 0; i < this.leaveApplied[i]; i++) {
      applyLeaveSelectedDates.push(new Date(this.leaveApplied[i]).getTime());
    }
    this.data = {
      "dateOfLeaves": applyLeaveSelectedDates,
      "comment": this.comment
    }
    this.serviceURLService.applyLeave(this.data, this.urlID).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      $("#applyLeaveModal").modal("show");
      this.successMessage = successData['message'];
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    }, errorData => {
      this.errorMessage = errorData.error.message;
      if (errorData.error.status === 400) {
        this.errorMessage = errorData.error.message;
      }
    });
  }

  public onDateSelected(value: any) {
    let myMoment: moment.Moment = moment(value);
    this.data.dateOfLeaves = [];
    console.log(value);
    const convertedValue = new Date(value).getTime();
    this.data.dateOfLeaves.push(convertedValue);
  }

  onMonthChange() {
    this.teamMemberLeaveCalender();
  }

  teamMemberLeaveCalender() {
    this.data = {
      'updatedTime': null,
    }

    this.value = this.selectedDates;
    this.serviceURLService.getScheduledLeaveCount(this.data, this.urlID).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      const memberName = successData.response.user.name;

      // for disabled holidays dates
      for (const holiday of successData.response.holidayForUser) {
        const appliedDate = new Date(holiday.dateOfHoliday);
        // append 0 in month for jan to sep
        const month = (appliedDate.getMonth() + 1 < 10 ? '0' + (appliedDate.getMonth() + 1) : appliedDate.getMonth() + 1);

        const dateId = (appliedDate.getFullYear().toString() + month.toString()
          + appliedDate.getDate().toString());
        const element = document.getElementById(dateId);
        if (typeof (element) != 'undefined' && element != null) {
          element.parentElement.classList.add('custom-disabled');
        }
      }

      if (successData.response.scheduledLeavesOfUser.length > 0) {
        for (let i = 0; i < (successData.response.scheduledLeavesOfUser).length; i++) {

          const appliedDate = new Date(successData.response.scheduledLeavesOfUser[i].dateOfLeave * 1);
          // append 0 in month for jan to sep
          var month = (appliedDate.getMonth() + 1 < 10 ? '0' + (appliedDate.getMonth() + 1) : appliedDate.getMonth() + 1);

          const dateId = (appliedDate.getFullYear().toString() + month.toString()
            + appliedDate.getDate().toString());
          const element = document.getElementById(dateId);
          console.log(element);
          if (successData.response.scheduledLeavesOfUser[i].leaveStatus === 'Unpaid') {

            if (typeof (element) != 'undefined' && element != null) {
              element.parentElement.classList.add('unpaid-leave-calender-status');
            }

          } else if (successData.response.scheduledLeavesOfUser[i].leaveStatus === 'Paid') {
            if (typeof (element) != 'undefined' && element != null) {
              element.parentElement.classList.add('paid-leave-calender-status');
            }

          } else if (successData.response.scheduledLeavesOfUser[i].leaveStatus === 'Rejected') {
            if (typeof (element) != 'undefined' && element != null) {
              element.parentElement.classList.add('rejected-leave-calender-status');
            }

          }
          this.selectedDates.push(new Date(successData.response.scheduledLeavesOfUser[i].dateOfLeave * 1));
          console.log('selected', this.selectedDates);
        }
      }
      else {
        $("#ignoreSelection").modal("show");
        $(".errorMessage").text(memberName + " has not applied any leave.");
        return;
      }

      this.value = this.selectedDates;
      console.log("master ", this.value)
      //this.storedDates = JSON.parse(JSON.stringify(this.selectedDates));
    }, errorData => {
      if (errorData.error.status === 401) {
        this.router.navigate(['/login']);
        console.log("Please login first");
      } else if (errorData.error.status === 403 || errorData.error.status === 400) {
        this.error = errorData.error.message;
        console.log("ERROR: ", this.error);
      }

    })
  }

  cancelLeaves() {
    var cancelLeaveSelectedDates = []
    for (var i = 0; i < this.leaveCancelled[i]; i++) {
      cancelLeaveSelectedDates.push(new Date(this.leaveCancelled[i]).getTime());
    }
    this.data = {
      "dateOfLeaves": cancelLeaveSelectedDates,
      "comment": this.comment
    }


    this.serviceURLService.cancelLeaveRequest(this.data, this.userID).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      //console.log("Successfully canceled leaves");
      $("#applyLeaveModal").modal("show");
      this.successMessage = "Successfully cancelled"
    }, errorData => {
      console.log("Not getting scheduled leaves");
    })
  }

  backClicked() {
    this._location.back();
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

}
